import dayjs from "dayjs";
var LocalizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(LocalizedFormat);

export const helpersFunctions = {
  tableOnFilterQuery,
  tableOnFilterQueryName,
  onPageHttpSkipQuery,
  dataCallsOnComponentUpdate,
  formatDate,
  handleCallError,
};

function tableOnFilterQuery(key, dataObj) {
  console.log(
    dataObj.columnsDataTable,
    dataObj.columnsDataTable.length,
    Object.keys(dataObj.columnsDataTable),
  );
  let tableQuery = Object.keys(dataObj.columnsDataTable).flatMap((key) => {
    return dataObj.columnsDataTable[key];
  });

  let objNameVal = tableQuery.filter((obj) => {
    return key == obj.name ? obj.data : null;
  });
  if (objNameVal.length == 0) {
    //if there's no matches, we did a repair or exhcange edit, and are refreshing data with the id of the repair/exchange

    return key;
  } else {
    return objNameVal[0].data;
  }
}

function tableOnFilterQueryName(key, dataObj) {
  // debugger;
  let tableQuery = Object.keys(dataObj.columnsDataTable).flatMap((key) => {
    return dataObj.columnsDataTable[key];
  });

  let objNameVal = tableQuery.filter((obj) => {
    return key == obj.data ? obj.name : null;
  });
  if (objNameVal.length > 0) {
    return objNameVal[0].name;
  }
}

function formatDate(dateStr, format = "DD/MM/YYYY") {
  let date = new Date(dateStr);

  //catch incase date entered is invalid so that it doesn't crash
  if (dateStr != "Invalid Date" && date != "Invalid Date") {
    return dayjs(date).format(format);
  } else {
    return;
  }
}

function onPageHttpSkipQuery(scope, options, APICalls) {
  var sortBy = tableOnFilterQuery(
    options.sort.sortBy,
    options.tableQuerySort,
  );

  if (options.queryStr || options.priceLineFiltering) {
    var strQryA = options.queryStr;
    var objNameQryA = tableOnFilterQuery(
      options.searchBy,
      options.tableQuery,
    );
    //if nothing has been chosen from the filtering table
    if (options.inboundStatus == null) {
      APICalls.orderQueryOData(
        {
          property: objNameQryA,
          query: strQryA,
          rows: options.pageRows,
          skip: options.startIndex,
          outboundStatus: null,

          priceLineFiltering: options.priceLineFiltering,
        },
        { sortby: sortBy, sortorder: options.sort.orderBy },
      ).then(
        (result) => {
          // merged data results to datasource
          scope.datasource.data = [
            ...scope.datasource.data,
            ...result.data,
          ];
          scope.setState({
            first: options.startIndex,
            rows: options.pageRows,
            orders: result.data,
            loading: false,
          });
          scope.props.setTableSettings({
            first: options.startIndex,
            rows: options.pageRows,
          });
        },
        (error) => {
          scope.httpErrorHandler(error);
        },
      );
    } else {
      //both inbound status and query str
      APICalls.orderQueryOData(
        {
          property: objNameQryA,
          query: strQryA,
          rows: options.pageRows,
          skip: options.startIndex,
          outboundStatus: options.inboundStatus,
        },
        { sortby: sortBy, sortorder: options.sort.orderBy },
      ).then(
        (result) => {
          // merged data results to datasource
          scope.datasource.data = [
            ...scope.datasource.data,
            ...result.data,
          ];
          scope.setState({
            first: options.startIndex,
            rows: options.pageRows,
            orders: result.data,
            loading: false,
          });
          scope.props.setTableSettings({
            first: options.startIndex,
            rows: options.pageRows,
          });
        },
        (error) => {
          scope.httpErrorHandler(error);
        },
      );
    }
  } else {
    //just inbound status
    APICalls.orderQueryOData(
      {
        property: options.outboundStatus,
        query: options.inboundStatus,
        rows: options.pageRows,
        skip: options.startIndex,
        outboundStatus: null,
      },
      { sortby: sortBy, sortorder: options.sort.orderBy },
    ).then(
      (result) => {
        // merged data results to datasource
        scope.datasource.data = [...scope.datasource.data, ...result.data];

        scope.setState({
          first: options.startIndex,
          rows: options.pageRows,
          orders: result.data,
          loading: false,
        });

        scope.props.setTableSettings({
          first: options.startIndex,
          rows: options.pageRows,
        });
      },
      (error) => {
        this.httpErrorHandler(error);
      },
    );
  }
}

function dataCallsOnComponentUpdate(scope, options, APICalls) {
  var sortBy = tableOnFilterQuery(
    options.state.sortBy,
    options.tableQuerySort,
  );

  if (
    options.props.inboundStatus != null &&
    (options.props.inboundStatus != options.prevProps.inboundStatus ||
      options.state.queryStr != options.prevState.queryStr ||
      options.prevState.sortBy != options.state.sortBy ||
      options.prevState.orderBy != options.state.orderBy)
  ) {
    if (!options.state.queryStr || options.state.searchBy === "Actions") {
      let entireDataset =
        options.state.searchBy === "Actions" ? true : false;
      APICalls.orderQueryOData(
        {
          property: options.outboundStatus,
          query: options.props.inboundStatus,
          rows: 10,
          skip: 0,
          outboundStatus: null,
          action:
            options.state.searchBy === "Actions"
              ? { name: options.state.queryStr, user: options.props.user }
              : null,
        },
        { sortby: sortBy, sortorder: options.state.orderBy },
        entireDataset,
      ).then(
        (result) => {
          // merged data results to datasource
          scope.datasource.data = result.data;
          scope.setState({
            orders: result.data,
            loading: false,
            rowCount: result.count,
            first: 0,
          });
        },
        (error) => {
          scope.httpErrorHandler(error);
        },
      );
    } else {
      var property = tableOnFilterQuery(
        options.state.searchBy,
        options.tableQuery,
      );
      APICalls.orderQueryOData(
        {
          property: property,
          query: options.state.queryStr,
          rows: 10,
          skip: 0,
          outboundStatus: options.props.inboundStatus,
        },
        { sortby: sortBy, sortorder: options.state.orderBy },
      ).then(
        (result) => {
          // merged data results to datasource
          scope.datasource.data = result.data;
          scope.setState({
            orders: result.data,
            loading: false,
            rowCount: result.count,
          });
        },
        (error) => {
          scope.httpErrorHandler(error);
        },
      );
    }
  } else if (
    options.props.inboundStatus == null &&
    (options.props.inboundStatus != options.prevProps.inboundStatus ||
      options.prevState.sortBy != options.state.sortBy ||
      options.prevState.orderBy != options.state.orderBy) &&
    (options.state.queryStr == "" || options.state.queryStr == null)
  ) {
    APICalls.orderNoQuery(options.state.rows, 0, {
      sortby: sortBy,
      sortorder: options.state.orderBy,
    }).then(
      (result) => {
        // merged data results to datasource
        scope.datasource.data = result.data;
        scope.setState({
          orders: result.data,
          loading: false,
          rowCount: result.count,
          first: 0,
        });

        scope.props.setTableSettings({
          first: 0,
          rows: 10,
        });
      },
      (error) => {
        scope.httpErrorHandler(error);
      },
    );
  }
  //if there is a query string but no inbound status
  else if (
    options.props.inboundStatus == null &&
    (options.props.inboundStatus != options.prevProps.inboundStatus ||
      options.prevState.sortBy != options.state.sortBy ||
      options.prevState.orderBy != options.state.orderBy) &&
    (options.state.queryStr != "" || options.state.queryStr != null)
  ) {
    var property = tableOnFilterQuery(
      options.state.searchBy,
      options.tableQuery,
    );
    if (options.state.searchBy === "Actions") {
      let sortBy = tableOnFilterQuery(
        options.state.sortBy,
        options.tableQuerySort,
      );
      APICalls.orderNoQuery(
        options.state.rows,
        0,
        {
          sortby: sortBy,
          sortorder: options.state.orderBy,
        },
        { name: options.state.queryStr, user: options.props.user },
      ).then(
        (result) => {
          // merged data results to datasource
          scope.datasource.data = result.data;
          scope.setState({
            orders: result.data,
            loading: false,
            rowCount: result.count,
            first: 0,
          });
        },
        (error) => {
          scope.httpErrorHandler(error);
        },
      );
    } else {
      APICalls.orderQueryOData(
        {
          property: property,
          query: options.state.queryStr,
          rows: 10,
          skip: 0,
          outboundStatus: undefined,
        },
        { sortby: sortBy, sortorder: options.state.orderBy },
      ).then(
        (result) => {
          // merged data results to datasource
          scope.datasource.data = result.data;
          scope.setState({
            orders: result.data,
            loading: false,
            rowCount: result.count,
          });
        },
        (error) => {
          scope.httpErrorHandler(error);
        },
      );
    }
  }
}

function handleCallError(err, defaultMessage) {
  //not sure if we might get an object or string, or where on object the most helpful error will be, so handling this to get the most useful info if something goes wrong
  const errorMessage =
    err &&
    err.response &&
    err.response.data &&
    err.response.data.statusDescription &&
    typeof err.response.data.statusDescription == "string"
      ? err.response.data.statusDescription
      : err &&
          err.response &&
          err.response.data &&
          err.response.data.statusDescription &&
          JSON.stringify(err.response.data.statusDescription).length
        ? JSON.stringify(err.response.data.statusDescription)
        : err &&
            err.response &&
            err.response.data &&
            typeof err.response.data == "string" &&
            err.response.data == "BadRequest: "
          ? "Sorry, there was a problem. Please contact your AJW contact for assistance."
          : err &&
              err.response &&
              err.response.data &&
              typeof err.response.data == "string"
            ? err.response.data
            : err && err.response && err.response.data
              ? JSON.stringify(err.response.data)
              : err && err.message
                ? err.message
                : err && err.title
                  ? err.title
                  : //incase we've already stingified it at some point and haven't removed the JWT
                    typeof err == "string" && err.includes("Authorization")
                    ? err.split("Authorization")[0]
                    : typeof err == "string" && err.length
                      ? err
                      : JSON.stringify(err) &&
                          JSON.stringify(err).includes("Authorization")
                        ? JSON.stringify(err).split("Autorization")[0]
                        : JSON.stringify(err).length
                          ? JSON.stringify(err)
                          : defaultMessage
                            ? defaultMessage
                            : "Sorry, there was a problem";

  return errorMessage;
}
